/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FreeBet, FreeBetInterface } from "../FreeBet";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "inc",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxFreeBets",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "max",
        type: "uint32",
      },
    ],
    name: "setMaxFreeBets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "usedFreeBets",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FreeBet__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FreeBet> {
    return super.deploy(overrides || {}) as Promise<FreeBet>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FreeBet {
    return super.attach(address) as FreeBet;
  }
  connect(signer: Signer): FreeBet__factory {
    return super.connect(signer) as FreeBet__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FreeBetInterface {
    return new utils.Interface(_abi) as FreeBetInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FreeBet {
    return new Contract(address, _abi, signerOrProvider) as FreeBet;
  }
}
